<script setup>
import { down, edgeFromDtRange, isImage, loadAuthImg, openWin, post, qsela, ymd } from '@/common/util'
import ConfirmCard from '@/components/ConfirmCard.vue'
import { useMemberStore, useMetaStore } from '@/stores'
import dayjs from 'dayjs'
import _ from 'lodash-es'
import { reactive } from 'vue'
import FileIcons from 'file-icons-vue'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import { onBeforeRouteUpdate } from 'vue-router'
import { useRouter,useRoute } from 'vue-router'
import config from '@/common/config'
const baseUrl = import.meta.env.BASE_URL;
const props=defineProps(['category']),meta=reactive({stats:['wait','ongoing','complete'],dtrange:[dayjs(new Date).subtract(7,'days').toDate(),new Date]
    ,stat:'all',sortcol:'cdt',isasc:false,page:1,size:20,data:{rows:[]},tblheight:400,mod:{reply:''}
    ,cols:[{tk:'categories',nm:'category',width:'130px'},{tk:'title',nm:'ttl',width:'auto'},{tk:'author',nm:'mid',width:'190px'},{tk:'status',nm:'stat',width:'85px'},{tk:'dateofenrollment',nm:'cdt',width:'120px'}]})
  ,metaStore=useMetaStore(),memStore=useMemberStore(),router=useRouter(),route=useRoute()
,sort=col=>{
  if(meta.sortcol==col)meta.isasc=!meta.isasc
  else meta.sortcol=col
  meta.page=1
  search()
},takecare=async()=>{
  metaStore.blockLoading()
  let res
  if(meta.category=='oneonone_inquery'){
    res=await post('rest/authed/admin/modinqueryreply',{refid:meta.selrow.id,cont:meta.mod.reply,etc:meta.mod.stat,id:meta.mod.replyid})
    meta.mod.reply=res.data.reply.cont
    meta.mod.replyid=res.data.reply.id
    meta.mod.stat=res.data.inquery.stat
    meta.selrow.stat=res.data.inquery.stat
    const replies=meta.data.subrows.replies
    const reply=replies.find(rep=>rep.id==meta.mod.replyid)
    if(reply){
      reply.cont=meta.mod.reply
    }else{
      replies.push(res.data.reply)
    }
  }else if(meta.category=='roadview_inquery'){
    delete meta.selrow.handler
    delete meta.selrow.author
    meta.selrow.stat=meta.mod.stat
    meta.selrow.memo=meta.mod.memo
    res=await post('rest/authed/admin/modinquery',meta.selrow)
    meta.selrow.stat=res.data.stat
    meta.selrow.admid=res.data.admid
    const mem=meta.data.subrows.mems.find(mem=>mem.mid==meta.selrow.admid)
    meta.selrow.author=`${mem.mname}(${mem.mid})`
  }
  meta.selrow.handler=`${memStore.mname}(${memStore.mid})`
  metaStore.toastRslt(res,true)
  metaStore.blockLoading(false)
},del=async()=>{
  metaStore.blockLoading()
  const res=await post('rest/authed/member/delinquery',{id:meta.tarid})
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,false)
  search()
},sel=async(row)=>{
  const pms={tartbl:'Inquery',rids:[row.id]}
  metaStore.blockLoading()
  const resfiles=await post('rest/authed/member/upfilepaths',pms)
  metaStore.blockLoading(false)
  if(resfiles.data.length>0){
    row.fid=resfiles.data[0].id
    row.fn=resfiles.data[0].fn
    row.furl=`/rest/authed/member/attachedfile/${row.fid}`;
    if(isImage(resfiles.data[0].filepath))row.imgdata=await loadAuthImg(row.furl)
  }
  meta.mod.stat=row.stat
  const replies=meta.data.subrows.replies
  const mems=meta.data.subrows.mems
  const reply=replies.find(rep=>rep.refid==row.id)
  if(reply){
    const mem=mems.find(mem=>mem.mid==reply.mid)
    row.replier=`${mem.mname}(${reply.mid})`
    meta.mod.reply=reply.cont
    meta.mod.replyid=reply.id
  }else{
    row.replier=null
    meta.mod.reply=null
    meta.mod.replyid=null
  }
  if(row.admid){
    const mem=mems.find(mem=>mem.mid==row.admid)
    row.handler=`${mem.mname}(${row.admid})`
  }
  meta.selrow=row
  router.push({hash: '#detail'})
},pop=(type,id)=>{
  meta.poptype=null
  metaStore.blockLoading(false)
  if(type=='del'){
    meta.tarid=id
    meta.popttl=metaStore.t('del_lbl_conttl').replace('_lbl_',metaStore.t('inquiries'))
    meta.popokact=del
    metaStore.pop({ison:true,callback:() =>meta.poptype='confirm'})
  }
},memdetail=async()=>{
  openWin(config.frontRoot+'admin/memdetail/'+meta.selrow.mid)
},setIfrCont=(ifr,cont)=>{
  if(cont)ifr.contentDocument.body.innerHTML=cont
},search=async()=>{
  const pms={where:{},dtcol:'cdt',...edgeFromDtRange(meta.dtrange),page:meta.page,size:meta.size,isasc:meta.isasc,sortcol:meta.sortcol}
  pms.where.category_eq_=meta.category
  if(meta.stat&&meta.stat!='all')pms.where.stat_eq_=meta.stat
  if(!_.isEmpty(meta.searchval))pms.where.ttl_or_=pms.where.cont_or_=meta.searchval
  metaStore.blockLoading()
  meta.data=await post('rest/authed/admin/inqueries',pms)
  metaStore.blockLoading(false)
  meta.data=meta.data.data
  const mems=meta.data.subrows.mems
  meta.data.rows.forEach(row=>row.author=`${mems.find(mem=>mem.mid==row.mid).mname}(${row.mid})`)
  meta.tblheight=window.innerHeight-400
}
meta.category='oneonone_inquery'
if(props.category)meta.category=props.category
search()
onBeforeRouteUpdate((to, from) => {
  if(!to.hash||to.hash=='')meta.selrow=null
})
</script>
<template>
  <div class="h-100 adminq">
    <v-card v-if="!meta.selrow" flat>
      <v-card-title>{{ $t(props.category=='roadview_inquery'?'roadview_inquery':'helpcenter11inquiries') }}</v-card-title>
      <v-sheet class="pa-3 bg-grey-lighten-3">
        <v-row>
          <v-col>
              <v-date-input hide-details variant="outlined" density="compact" prepend-icon="" prepend-inner-icon="$calendar" v-model="meta.dtrange" :label="$t('select_range')" multiple="range"/>
          </v-col>
          <v-col cols="2">
            <v-select hide-details density="compact" variant="outlined" :items="meta.stats" v-model="meta.stat" :item-title="$t" :item-value="val=>val"/>
          </v-col>
          <v-col>
            <v-text-field hide-details density="compact" variant="outlined" :label="$t('pleaseenteryoursearchterm')" v-model="meta.searchval"/>
          </v-col>
          <v-col cols="1">
            <v-btn prepend-icon="mdi-magnify" color="secondary" :text="$t('search')" @click="search"/>
          </v-col>
        </v-row>
      </v-sheet>
      <v-card-text>
        <v-table fixed-header :height="meta.tblheight">
          <thead>
            <tr class="bg-grey-lighten-4">
              <th v-for="col in meta.cols" class="text-center cursor-pointer" :style="col.width?'width:'+col.width:''" @click="sort(col.nm)">{{ $t(col.tk)}}
                <v-icon v-if="meta.data.rows.length>0&&col.nm==meta.sortcol" :icon="meta.isasc?'mdi-arrow-up':'mdi-arrow-down'"/>
              </th>
              <th class="text-center" style="width: 100px;">{{ $t('viewdetails') }}</th>
              <th class="text-center" style="width: 100px;">{{ $t('delete') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="meta.data.rows.length==0">
              <td :colspan="meta.cols.length+2" class="text-center">{{ $t('noresultsfound') }}</td>
            </tr>
            <tr v-else v-for="row in meta.data.rows">
              <td v-for="col in meta.cols">
                <div v-if="['category','stat'].includes(col.nm)" class="text-center">{{ $t(row[col.nm]) }}</div>
                <div v-else-if="col.nm=='cdt'">{{ ymd(row[col.nm]) }}</div>
                <div v-else>{{ row[col.nm] }}</div>
              </td>
              <td><v-btn :text="$t('viewdetails')" @click="sel(row)"/></td>
              <td><v-btn color="error" :text="$t('delete')" @click="pop('del',row.id)"/></td>
            </tr>
          </tbody>
        </v-table>
      </v-card-text>
      <v-card-actions>
          <v-pagination class="ma-auto" v-if="meta.data.rows.length>0" :length="meta.data.totalPages" :total-visible="meta.data.pageCount" v-model="meta.page" @update:model-value="search"/>
        </v-card-actions>
    </v-card>
    <v-card v-else flat>
      <v-card-title>{{ `${$t(meta.category)} ${$t('detailcontents')}` }}</v-card-title>
      <v-card-text style="height: calc(100vh - 264px);overflow-y: auto;">
        <v-table class="adminqdetail">
          <tbody>
            <tr>
              <th>{{ $t('categories') }}</th>
              <td width="40%">{{ $t(meta.selrow.category) }}</td>
              <th>{{ $t('status') }}</th>
              <td>{{ $t(meta.selrow.stat) }}</td>
            </tr>
            <tr>
              <th>{{ $t('author') }}</th>
              <td :colspan="meta.category=='oneonone_inquery'?3:1">
                <v-row>
                  <v-col class="pt-5">{{ meta.selrow.author }}</v-col>
                  <v-col class="text-right"><v-btn :text="$t('viewinformation')" @click="memdetail"/></v-col>
                </v-row>
              </td>
              <template v-if="meta.category=='roadview_inquery'">
                <th>{{ $t('companyperiodname') }}</th>
                <td>{{ meta.selrow.company }}</td>
              </template>
            </tr>
            <tr v-if="meta.category=='roadview_inquery'">
              <th>{{ $t('email') }}</th>
              <td>{{ meta.selrow.email }}</td>
              <th>{{ $t('contact') }}</th>
              <td>{{ meta.selrow.contact }}</td>
            </tr>
            <tr v-if="meta.category=='roadview_inquery'">
              <th>{{ $t('desiredregion') }}</th>
              <td colspan="3">{{ meta.selrow.tarloc }}</td>
            </tr>
            <tr>
              <th>{{ $t('title') }}</th>
              <td colspan="3">{{ meta.selrow.ttl }}</td>
            </tr>
            <tr>
              <th>{{ $t('contents') }}</th>
              <td colspan="3">
                <!-- <iframe class="conifr" :src="baseUrl+'blank.html'" @load="setIfrCont($event.target,meta.selrow.cont)" style="border-width: 0;width: 100%;min-height: 300px;"></iframe> -->
                <div class="inquerycontquill ">
                  <QuillEditor theme="snow" class="w-100" content-type="html" :content="meta.selrow.cont" @ready="evt=>{
                    qsela('.inquerycontquill .ql-toolbar').forEach(el=>el.remove())
                    qsela('.inquerycontquill .ql-editor').forEach(el=>el.contentEditable=false)
                    qsela('.inquerycontquill .ql-container').forEach(el=>el.style.borderWidth=0)
                  }"/>
                </div>
              </td>
            </tr>
            <tr v-if="meta.category=='oneonone_inquery'">
              <th>{{ $t('fileattachments') }}</th>
              <td colspan="3">
                <div v-if="meta.selrow.fid">
                  <img v-if="meta.selrow.imgdata" :src="meta.selrow.imgdata" class="mt-2" style="max-width: 500px;max-height: 500px;"/>
                  <div>
                      <v-btn class="mt-2 mb-2" @click="down({url:meta.selrow.furl,method:'get'})">
                      <FileIcons :name="meta.selrow.fn"/>
                      {{ $t('download') }}
                      </v-btn>
                  </div>
                </div>
              </td>
            </tr>
            <tr v-if="meta.category=='oneonone_inquery'">
              <th>{{ $t('answer') }}</th>
              <td colspan="3" class="pa-2">
                <QuillEditor theme="snow" class="inqueryquill w-100" content-type="html" :content="meta.mod.reply" @update:content="html=>meta.mod.reply=html"/>
              </td>
            </tr>
            <tr v-if="meta.category=='roadview_inquery'">
              <th>{{ $t('memo') }}</th>
              <td colspan="3" class="pa-2">
                <QuillEditor theme="snow" class="inqueryquill w-100" content-type="html" :content="meta.selrow.memo" @update:content="html=>meta.mod.memo=html"/>
              </td>
            </tr>
            <tr>
              <th>{{ $t('status')+' '+$t('makingchanges') }}</th>
              <td colspan="3">
                <v-select hide-details density="compact" variant="outlined" :items="meta.stats.filter(stat=>stat!='status')" v-model="meta.mod.stat" :item-title="$t" :item-value="val=>val"/>
              </td>
            </tr>
            <tr>
              <th>{{ $t('handler') }}</th>
              <td colspan="3">{{ meta.selrow.handler }}</td>
            </tr>
          </tbody>
        </v-table>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col>
            <v-btn variant="elevated" :text="$t('tolist')" @click="meta.selrow=null"/>
          </v-col>
          <v-col class="text-right">
            <v-btn variant="elevated" :text="$t('cancel')" @click="meta.selrow=null" class="me-3"/>
            <v-btn variant="elevated" color="primary" :text="$t('save')" @click="takecare"/>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
  <teleport v-if="meta.poptype" to="#popbody">
    <ConfirmCard v-if="meta.poptype=='confirm'" :ttl="meta.popttl" :cont="meta.popcont" @cancel="metaStore.blockLoading(false)" @confirm="meta.popokact"/>
  </teleport>
</template>
<style>
.adminq .v-input__control{background-color: rgba(255,255,255,1);}
.adminqdetail th{background-color: #EEEEEE;width: 120px;text-align: center !important;}
.adminqdetail{border: 1px solid #e0e0e0;}
</style>
